import { useSos } from '../model/useSos'
import BreathingDialog from './BreathingDialog'
import styles from './SosPage.module.css'

export default function SosPage() {
  const { open, openPractice, closePractice } = useSos()
  return (
    <section className={styles.page} aria-labelledby="sos-title">
      <div className={styles.inner}>
        <p className={styles.kicker}>Экстренная поддержка</p>
        <h1 id="sos-title" className={styles.title}>Если прямо сейчас очень тяжело</h1>
        <p className={styles.lead}>
          Нажмите кнопку — откроется короткая дыхательная практика. Она помогает
          телу успокоиться, пока волна не спадёт.
        </p>
        <button type="button" className={styles.sosButton} onClick={openPractice} aria-haspopup="dialog">
          <span className={styles.orbit} aria-hidden="true"><span className={styles.dot} /></span>
          <span className={styles.core}>SOS</span>
        </button>
        <p className={styles.note}>Практика занимает около минуты. Можно повторять сколько нужно.</p>
      </div>
      <section className={styles.contacts} aria-labelledby="sos-contacts-title">
        <h2 id="sos-contacts-title" className={styles.contactsTitle}>Контакты помощи в России</h2>
        <a className={styles.contact} href="tel:112">
          <span className={styles.contactNumber}>112</span>
          <span>Единая служба спасения</span>
        </a>
        <a className={styles.contact} href="tel:88003334434">
          <span className={styles.contactNumber}>8-800-333-44-34</span>
          <span>Всероссийская линия доверия</span>
        </a>
        <a className={styles.contact} href="tel:88007000600">
          <span className={styles.contactNumber}>8-800-7000-600</span>
          <span>Для женщин, переживших домашнее насилие</span>
        </a>
      </section>
      {open && <BreathingDialog onClose={closePractice} />}
    </section>
  )
}
